export function reducerEtapas(state:any, action:any) {
  if (typeof action === 'function') return action(state)

  if (action.type === 'VOLTAR') return { ...state, posicao: state.posicao - 1 };
  if (action.type === 'AVANCAR') return { ...state, posicao: state.posicao + 1 };

  return state;
}